<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-6 mt-6">
                <!--                <img src="../assets/logo.svg" alt="" class="mb-4">-->
                <!--                <img src="../assets/slogan.svg" alt="" class="mb-4">-->
                <div class="card">
                    <div class="card-header"><h4 class="card-title">Login</h4></div>
                    <div class="card-body" v-if="user">
                        <form @submit.prevent="login" novalidate>
                            <app-input v-model="user.email"
                                       placeholder="Email"
                                       field="email"
                                       :errors="errors"/>
                            <app-input v-model="user.password"
                                       placeholder="Password"
                                       type="password"
                                       field="password"
                                       :errors="errors"/>
                            <button class="btn btn-primary float-right"
                                    type="submit"
                                    :disabled="submitted">Login
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppInput from '../components/form/AppInput';
import NotificationService from '../services/notification.service';
import Errors from '../utils/errors';
import store from '../store/store';

export default {
  data() {
    return {
      errors: new Errors(),
      submitted: false,
      user: null,
    };
  },
  mounted() {
    this.resetUser();
  },
  components: {
    AppInput,
  },
  methods: {
    resetUser() {
      this.user = {
        email: '',
        password: '',
      };
    },
    login() {
      this.errors.clear();
      this.submitted = true;
      this.$store.dispatch('auth/login', this.user)
        .then((res) => {
          this.resetUser();
          NotificationService.success(`Hello, ${res.data.user.first_name}!`, 'Logged in!');
        })
        .catch((err) => this.errors.set(err.response.data.errors))
        .finally(() => {
          this.submitted = false;
        });
    },
  },
  beforeRouteEnter: (to, from, next) => {
    store.dispatch('auth/loginGuard');
    next();
  },
};
</script>
